// extracted by mini-css-extract-plugin
module.exports = {"certification-info":"style_certification-info__2GfhV"};